import { currrencyFomats } from './currency-formats.const'

/**
 * Get all of the supported currency codes.
 *
 * @returns arr of supported ISO 4217 currency codes
 */
export const getCurrencyCodes = () => {
  return Object.keys(currrencyFomats)
}
